/*
 * (c) 2021 Daniel Kruse <d.kruse@atlantisdx.de>, atlantis dx GmbH
 */
import $ from 'jquery';

(($) => {
	const $searchForm = $('.news-search-form');
	$searchForm
		.find('.btn-reset')
		.off('click')
		.on('click', () => {
			$searchForm.find('input[type=text]').val('');
			$searchForm.find('select').val('');
		});
})($);
